import React from 'react';

import { SVGComponentProps } from './svg.types';

const SendChatQuestionSVG = ({
  stroke = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <rect width="42" height="42" rx="21" fill="#254DDA" />
        <g clipPath="url(#clip0_4781_86269)">
          <path
            d="M28.5 13.5L20.25 21.75"
            stroke={stroke}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.5 13.5L23.25 28.5L20.25 21.75L13.5 18.75L28.5 13.5Z"
            stroke={stroke}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_4781_86269">
            <rect width="18" height="18" fill="white" transform="translate(12 12)" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default SendChatQuestionSVG;
